import React from "react";
import { Button } from "@mui/material";

import { ActivityThread, ActivityThreadComposer } from "../../../../components/ActivityThread/ActivityThread";
import { SectionCard, formatDateTime } from "../coreNetworkUiShared";

export default function CoreNetworkMessageThread({
  messages = [],
  onSendMessage,
  onUploadAttachments,
  onOpenAttachment,
  onMarkRead,
  sending = false,
  uploading = false,
  unreadCount = 0,
}) {
  return (
    <SectionCard
      title="Messages"
      subtitle={`Conversation with the assigned provider and internal team.${unreadCount ? ` ${unreadCount} unread.` : ""}`}
      action={
        onMarkRead ? (
          <Button variant="text" size="small" onClick={onMarkRead} disabled={!unreadCount}>
            Mark read
          </Button>
        ) : null
      }
    >
      <div className="activity-thread">
        <ActivityThread
          messages={messages}
          formatTimestamp={formatDateTime}
          onOpenAttachment={onOpenAttachment}
          emptyDescription="Start the conversation with the assigned provider or leave an internal note for your team."
        />
        {onSendMessage ? <ActivityThreadComposer onSubmit={onSendMessage} onUploadAttachments={onUploadAttachments} sending={sending} uploading={uploading} defaultInternal /> : null}
      </div>
    </SectionCard>
  );
}
